import RangeBtn from './RangeBtn';
// import DateRange from './DateRangePicker'
import DateRange from './RangePicker';
import DatePicker from './DatePicker';
// 日期控件中文格式化
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const RangePicker = DateRange;

export default {
  RangeBtn,
  DateRange,
  DatePicker,
  RangePicker
};
export {
  // RangeBtn,
  DateRange,
  DatePicker,
  RangePicker
};
